import React from 'react';

const ProgressBar = ({ used, total, colorClass = 'bg-indigo-600' }) => {
  const percentage = Math.min((used / total) * 100, 100);
  const isOverLimit = used > total;

  return (
    <div className="w-full bg-gray-200 rounded-full h-2.5 overflow-hidden">
      <div
        className={`h-2.5 rounded-full ${isOverLimit ? 'bg-red-500' : colorClass}`}
        style={{ width: `${percentage}%` }}
      ></div>
    </div>
  );
};

export default ProgressBar;